export default __webpack_public_path__ + "static/media/miguel-lopes-23.c864c369.jpg";